import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/page/statistics/sliderToFourBox.css");
;
import(/* webpackMode: "eager" */ "/app/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeScript"] */ "/app/components/themeScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/website/BlogChatFrame.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
